import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

export class LeaveDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): LeaveDateTime {
    return new LeaveDateTime(value);
  }

  /** キー */
  static get key(): string {
    return 'leaveDateTime';
  }

  /** ラベル */
  static get label(): string {
    return '降園時刻';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
